<template>
  <div class="DrkWhite pa-4">
      <h2 class="subheading green--text">Unit Measures</h2>
      <v-card class="mt-4">
      <UnitMeasure/>
  </v-card>
  </div>
</template>

<script>
import UnitMeasure from '@/components/Utils/UnitMeasure.vue'
  export default {
    components: {
      UnitMeasure
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>